/**
 * TX Notes Thunks
 *
 * Each thunk:
 *  - takes { patientId, customerId, ...payload }
 *  - returns { patientId, patient } on success so the slice can
 *    update openedPatients without knowing the _id inside the handler
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../api';

export const addTxNote = createAsyncThunk(
  'emr/addTxNote',
  async ({ patientId, customerId, note, date }, { rejectWithValue }) => {
    try {
      const data = await api.addTxNote(customerId, note, date);
      return { patientId, patient: data.patient };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to add note');
    }
  }
);

export const updateTxNote = createAsyncThunk(
  'emr/updateTxNote',
  async ({ patientId, customerId, noteId, note }, { rejectWithValue }) => {
    try {
      const data = await api.updateTxNote(customerId, noteId, note);
      return { patientId, noteId, patient: data.updatedPatientProfile };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to update note');
    }
  }
);

export const updateGeneralNote = createAsyncThunk(
  'emr/updateGeneralNote',
  async ({ patientId, customerId, generalNote }, { rejectWithValue }) => {
    try {
      const data = await api.updateGeneralNote(customerId, generalNote);
      return { patientId, patient: data.patient };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to update general note');
    }
  }
);

export const deleteTxNote = createAsyncThunk(
  'emr/deleteTxNote',
  async ({ patientId, customerId, noteId }, { rejectWithValue }) => {
    try {
      const data = await api.deleteTxNote(customerId, noteId);
      return { patientId, noteId, patient: data.updatedPatientProfile };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to delete note');
    }
  }
);
